import React from 'react'
import cx from 'classnames'
import { changeWorkspace } from 'webmango-core/effects/workspace'
import { toName } from 'webmango-core/selectors/workspace'
import groupBy from 'lodash/groupBy'
import { Select } from '../../Form'
import { ControlButton, ControlLink } from '../../Controls'

import { WaitMessage } from '../../StatusMessage'
import withErrorBoundary from '../../ErrorBoundary'

export default withErrorBoundary(class SelectWorkspace extends React.PureComponent {
  initialState = {
    isChangingWorkspace: undefined
  }

  state = { ...this.initialState }

  onChangeWorkspace = (event) => {
    const workspace = event.target.value
    this.props.setState({ workspace })
  }

  onSelectWorkspace = async (event) => {
    this.setState({ isChangingWorkspace: true })
    await changeWorkspace({ id: this.props.workspace })
  }

  onSignOut = async () => {
    this.setState(this.initialState)
    return this.props.onSignOut()
  }

  componentDidMount () {
    window.addEventListener('keydown', this.onKeyDown)
  }

  componentWillUnmount () {
    window.removeEventListener('keydown', this.onKeyDown)
  }

  onKeyDown = (event) => {
    // enter to select workspace
    if (event.key === 'Enter') {
      if (document.activeElement !== document.body) return
      this.onSelectWorkspace()
    }
  }

  render () {
    const {
      className,
      profile = {},
      identities,
      workspaces = {},
      workspace
    } = this.props

    const { isChangingWorkspace } = this.state

    let workspaceGroups = {}

    if (profile.email && Object.values(workspaces).length) {
      const workspaceAllGroups = groupBy(Object.values(workspaces), 'email')
      workspaceGroups = {
        [profile.email]: workspaceAllGroups[profile.email] || [], // own first
        ...workspaceAllGroups
      }
    }

    return (
      <div className={cx('SelectWorkspaces', className)}>
        <div className='LoginWorkspaces Form'>
          <label className='selectWorkspaceLabel' htmlFor='workspace'>
            Select Workspace&nbsp;
          </label>
          <div className='FormItem'>
            <div className='inputContainer'>
              <Select
                name='workspace'
                value={workspace}
                onChange={this.onChangeWorkspace}
              >
                {Object.entries(workspaceGroups).map(([ email, workspaces ]) => {
                  if (!workspaces || !email) return null
                  const groupLabel = `${email === profile.email ? 'Yours' : `${identities[email].name} (${email})`}`
                  return (
                    <optgroup key={email} label={groupLabel}>
                      {workspaces.map(w => (
                        <option key={w.id} value={w.id}>
                          {identities[email].name}&nbsp;&mdash;&nbsp;
                          {toName(profile, w)}
                          &nbsp;
                        </option>
                      ))}
                    </optgroup>
                  )
                })}
              </Select>
            </div>
          </div>
          <ControlLink
            to={{
              pathname: '/register',
              search: window.location.search
            }}
          >
            Create New Workspace
          </ControlLink>
          <ControlButton autoFocus className='default' onClick={this.onSelectWorkspace}>Select</ControlButton>
        </div>
        <div>
          <div className={cx('ChangingWorkspace', 'showable', { show: workspaces && isChangingWorkspace })}>
            <WaitMessage title={`Selecting Workspace...`} />
          </div>
        </div>
        <div className='LoginDetails'>
          <a onClick={this.onSignOut}>Sign Out</a>&nbsp;&nbsp;
          {profile.email}
        </div>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/Login/Workspace/Select.js